/**
 * PostHog Analytics Service
 * Simple wrapper around posthog-js for tracking events
 */
import posthog from 'posthog-js';

// Helper to safely capture events
const track = (event, properties = {}) => {
  try {
    posthog.capture(event, properties);
  } catch (error) {
    console.error('[PostHog] Failed to capture event:', event, error);
  }
};

// Phone Collection Flow
export const phoneCollectionStarted = () => track('phone_collection_started');

export const phoneSubmitted = (countryCode) => track('phone_submitted', { country_code: countryCode });

export const smsVerificationStarted = () => track('sms_verification_started');

export const phoneVerified = () => track('phone_verified');

export const identify = (phoneNumber, properties = {}) => {
  try {
    posthog.identify(phoneNumber, { phone_number: phoneNumber, ...properties });
  } catch (error) {
    console.error('[PostHog] Failed to identify user:', error);
  }
};

// Questionnaire Flow
export const questionnaireStarted = (sessionId, isResuming, totalQuestions) =>
  track('questionnaire_started', { session_id: sessionId, is_resuming: isResuming, total_questions: totalQuestions });

export const questionViewed = (questionKey, questionIndex) =>
  track('question_viewed', { question_key: questionKey, question_index: questionIndex });

export const questionAnswered = (questionKey, answer) =>
  track('question_answered', { question_key: questionKey, answer });

export const questionNavigation = (direction, fromIndex, toIndex) =>
  track('question_navigation', { direction, from_index: fromIndex, to_index: toIndex });

export const questionnaireCompleted = (sessionId, questionCount) =>
  track('questionnaire_completed', { session_id: sessionId, question_count: questionCount });

// Analysis Flow
export const analysisLoadingViewed = (sessionId) =>
  track('analysis_loading_viewed', { session_id: sessionId });

export const analysisViewed = (sessionId, recommendationCount) =>
  track('analysis_viewed', { session_id: sessionId, recommendation_count: recommendationCount });

export const recommendationClicked = (cardName, bankName) =>
  track('recommendation_clicked', { card_name: cardName, bank_name: bankName });

// Profile
export const profileViewed = () => track('profile_viewed');

export const profileUpdated = (updatedFields) =>
  track('profile_updated', { updated_fields: updatedFields });

// Recommendations List
export const recommendationsListViewed = (sessionCount) =>
  track('recommendations_list_viewed', { session_count: sessionCount });

// Sign Out
export const signOut = () => {
  track('sign_out');
  try {
    posthog.reset();
  } catch (error) {
    console.error('[PostHog] Failed to reset:', error);
  }
};

// Export as service object for backward compatibility
export const posthogService = {
  phoneCollectionStarted,
  phoneSubmitted,
  smsVerificationStarted,
  phoneVerified,
  identify,
  questionnaireStarted,
  questionViewed,
  questionAnswered,
  questionNavigation,
  questionnaireCompleted,
  analysisLoadingViewed,
  analysisViewed,
  recommendationClicked,
  profileViewed,
  profileUpdated,
  recommendationsListViewed,
  signOut,
};
